import { HTMLAttributes } from 'react'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'

import PauseIcon from '/icons/pause.svg'
import PlayIcon from '/icons/play.svg'

export interface PlayControlProps extends HTMLAttributes<HTMLButtonElement> {
  className?: string;
  isPause: boolean;
}

export default function PlayControl (props: PlayControlProps) {
  const { className, isPause, ...rest } = props

  return (
    <button
      type="button"
      className={cn('reset-button', className, styles.root)}
      {...rest}
    >
      {isPause && <img src={PauseIcon} />}
      {!isPause && <img src={PlayIcon} />}
    </button>
  )
}
